import { isEmpty } from "lodash";
import { eProviderId, News } from "../../@types/Analysis";
import { uncapitalize } from "../../utils";


export function generatePostContent(news: News): string | null {
    const { name, content } = news;
    let generatedContent = "";

    if (!isEmpty(name) && !isEmpty(content)) {
        generatedContent = `${name}, ${uncapitalize(content)}`;
    } else if (!isEmpty(content)) {
        generatedContent = content;
    } else if (!isEmpty(name)) {
        generatedContent = name;
    }

    if (generatedContent) {
        return sanitizeContent(generatedContent, news.providerID);
    }

    return null;
}

export function sanitizeContent(content: string, providerId: eProviderId): string {
    let newContent = content;
    const removableTexts = [
        'Reuters',
        'The post',
        'appeared first on InfoMoney.',
        'leia mais',
        'Leia mais',
        'São Paulo (Reuters) - ',
        '(Reuters) - ',
        '     ',
        '  ',
    ];

    const affectedProviders = [
        eProviderId.REUTERS,
        eProviderId.BRAZILIAN_MIXED
    ];

    if (providerId === eProviderId.REUTERS) {
        const reutersIntroEndPosition = content.indexOf('-');
        newContent = content.slice((reutersIntroEndPosition + 1), -1);
    }

    if (affectedProviders.includes(providerId)) {
        removableTexts.forEach((removableText) => {
            if (content.includes(removableText)) {
                newContent = newContent.replace(removableText, '');
            }
        })
    }

    return newContent;
}